import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import {
  editTextReset,
  editColor,
  editFontSize,
  editFontWeight,
  editPreFontSize,
  editText
} from 'src/store/modules/editText';
import {
  buttonsReset,
  editBtnBgColor,
  editBtnColor,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnText
} from 'src/store/modules/buttons';
import {
  imageReset,
  editBgImage,
  editRadius,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';

import setInitValue from 'src/utils/setInitValue';
import { changeText } from 'src/utils/changeText';
import { changeEnter } from 'src/utils/changeEnter';
import { trackingReset } from 'src/store/modules/trackings';
import { editUserCompany } from 'src/store/modules/client';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/BottomSheetImageTracking';

const initViewValues = {
  currentIndex: 0,
  bg: 'color',
  bgOpacity: { bgDimmed: 70 },
  bgImage: {
    background: '',
    multi_image: [
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
    ]
  },
  bgColor: {
    background: '#ffffff'
  },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },
  radius: { multi_image: 16, multi_button: 0, multi_sub_button: 0 },

  text: {
    multi_title: ['SALE UP TO 10%', 'SALE UP TO 20%', 'SALE UP TO 30%'],
    multi_sub_title: [
      'Get a designer brand products at a sale price. Give away a 10$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 20$ coupon for members.',
      'Get a designer brand products at a sale price. Give away a 30$ coupon for members.'
    ]
  },
  fontSize: { multi_title: 1.25, multi_sub_title: 0.75 },
  fontWeight: { multi_title: 700, multi_sub_title: 400 },
  color: { multi_title: '#000000', multi_sub_title: '#000000' },
  fontFamily: { multi_title: 'Montserrat', multi_sub_title: 'Montserrat' },
  textAlign: { multi_title: 'left', multi_sub_title: 'left' },

  btnText: {
    multi_button: ['SHOW UP 1', 'SHOW UP 2', 'SHOW UP 3'],
    multi_sub_button: ['LATER 1', 'LATER 2', 'LATER 3']
  },
  btnFontSize: { multi_button: 1, multi_sub_button: 1 },
  btnFontWeight: { multi_button: 500, multi_sub_button: 500 },
  btnColor: { multi_button: '#ffffff', multi_sub_button: '#000000' },
  btnBgColorR: { multi_button: 0, multi_sub_button: 0 },
  btnBgColorG: { multi_button: 0, multi_sub_button: 0 },
  btnBgColorB: { multi_button: 0, multi_sub_button: 0 },
  btnBgColorA: { multi_button: 1, multi_sub_button: 0 },
  btnFontFamily: { multi_button: 'Montserrat', multi_sub_button: 'Montserrat' }
};

const BottomSheetImage: FC = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const clientName = useSelector(
    (state: RootState) => state.client.userCompany
  );
  const templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const multiTitleURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonURL = getFontURL(btnFontFamily?.multi_button);
  const multiSubButtonURL = getFontURL(btnFontFamily?.multi_sub_button);
  // const multiTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_title}`;
  // const multiSubTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_sub_title}`;
  // const multiButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;
  // const multiSubButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_sub_button}`;

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleURL});
    }

  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleURL});
    }

  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonURL});
    }

  @font-face {
    font-family: 'multiSubButton';
    src: url(${multiSubButtonURL});
    }
  
    .root_view {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    
    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0,${displayValue});
    }
    .modal_wrapper {
      width: 100%;
      height: 32rem;

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0 0;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      height: 15.5rem;
      outline: none;
    }

    .slick_wrapper {
      position: absolute;
      top: 0;
      left: 0;
    }
    .slick-track {
      display: flex;
    }
    .slick-track img {
      object-fit: cover;
    }
    .slick_page {
      padding: 0.25rem 1rem;
      position: absolute;
      top: 1rem;
      right: 0.94rem;

      display: flex;
      gap: 0.25rem;

      color: #fff;
      font-family: Roboto;
      font-size: 0.875rem;
      font-weight: 500;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .contents_wrapper {
      margin-top: 15.5rem;
      height: 16.5rem;
      padding: 0 10%;

      width: 100%;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
    }
    .contents_box {
      width: 100%;
      height: 8rem;
      padding: 1.5rem 0 0.5rem 0;
    }
    .contents_box .title {
      width: 100%;
      height: 2rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .btn_wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      position: relative;
    }
    .btn_wrapper button {
      height: 3rem;
      border: 0;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      cursor: pointer;
      color: ${btnColor?.multi_button};
      font-weight: ${btnFontWeight?.multi_button};
      font-size: ${btnFontSize?.multi_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily?.multi_button
          : 'multiButton'
      };

      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      cursor: pointer;
      color: ${btnColor?.multi_sub_button};
      font-weight: ${btnFontWeight?.multi_sub_button};
      font-size: ${btnFontSize?.multi_sub_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_sub_button
        )
          ? btnFontFamily?.multi_sub_button
          : 'multiSubButton'
      };

      border-radius: ${radius?.multi_sub_button}px;
      background-color: rgba(${btnBgColorR?.multi_sub_button},${
    btnBgColorG?.multi_sub_button
  }, ${btnBgColorB?.multi_sub_button}, ${btnBgColorA?.multi_sub_button});
    }

    ${
      templateWidth > 767
        ? `
        .modal_wrapper {
          height: 52rem;
        }
        .contents_wrapper {
          margin-top: 29.0625rem;
          height: 22.94rem;
          padding: 0 25%;
        }

        .slick_wrapper,
        .slick_wrapper .slick-slider,
        .slick_wrapper .slick-list,
        .slick_wrapper .slick-track div,
        .slick_wrapper .slick-track img {
          height: 29.0625rem;
        }
        .contents_box {
          height: 10.5rem;
          padding: 2rem 0 1rem 0;
        }
        .contents_box .title {
          height: 3rem;
          margin-bottom: 0.5rem;
          font-size: ${fontSize?.multi_title + 0.75}rem;
        }
        .contents_box .sub_title {
          font-size: ${fontSize?.multi_sub_title + 0.25}rem;
          -webkit-line-clamp: 3;
        }

        .btn_wrapper {
          gap: 1rem;
        }
        .btn_wrapper button {
          height: 4rem;
        }
          `
        : ''
    }
    }
  `;

  const settings = {
    arrows: false,
    infinite: true,
    dots: false,

    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    touchThreshold: 300,
    letiableWidth: true
  };

  const contentsSettings = {
    arrows: false,
    infinite: true,
    fade: true,

    speed: 300,
    touchThreshold: 300,
    swipe: false
  };

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
    // buttonSliderRef1.current.slickGoTo(currentIndex);
    // buttonSliderRef2.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          if (
            customValues?.bgImage &&
            customValues?.text &&
            customValues?.btnText
          ) {
            setInitValue(dispatch, customValues);
          } else {
            setValue(
              dispatch,
              customValues,
              { ...initViewValues, ...initTrackingValues },
              clientName
            );
          }
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());

      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="modal_wrapper">
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
                contentsSliderRef.current.slickGoTo(index);
              }}
            >
              {bgImage?.multi_image?.map((data: any, idx: number) => (
                <div
                  key={idx}
                  style={{ display: 'inline-block' }}
                  data-btn-text="Shop now"
                  data-btn-href="javascrupt:01;"
                >
                  <img
                    className="image"
                    src={bgImage?.multi_image[idx]}
                    alt="half top"
                  />
                </div>
              ))}
            </Slider>
            {bgImage?.multi_image?.length !== 1 && (
              <div className="slick_page">
                <span>{currentIndex + 1}</span>
                <span className="slash">/</span>
                <span>{bgImage?.multi_image?.length}</span>
              </div>
            )}
          </div>
          <div className="contents_wrapper">
            <Slider {...contentsSettings} ref={contentsSliderRef}>
              {text?.multi_title?.map((data: any, idx: number) => (
                <div key={idx} className="contents_box">
                  <div className="title">{changeEnter(data)}</div>
                  <div className="sub_title">
                    {changeEnter(text?.multi_sub_title?.[idx])}
                  </div>
                </div>
              ))}
            </Slider>
            <div className="btn_wrapper">
              <button className="style01">
                {btnText?.multi_button?.[currentIndex]}
              </button>
              <button className="style02">
                {btnText?.multi_sub_button?.[currentIndex]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const setValue = (
  dispatch: any,
  values: any,
  initViewValuess: any,
  clientName: any
) => {
  // console.log(values);
  // console.log('test');
  // dispatch(editBgColor(values?.bgColor));
  const MultiBackground = values?.imageName?.map(
    (data: any) => `https://image.inappmessage.com/${clientName}/${data}`
  );
  dispatch(
    editBgImage({
      multi_image: MultiBackground
    })
  );
  // dispatch(editBgImageBlur(values?.bgImageBlur));
  dispatch(editDeeplink({ multi_image: values?.newDeepLink }));
  dispatch(
    editRadius({
      ...initViewValuess?.radius,
      ...{ multi_image: values?.newImgRadius }
    })
  );

  const newText = values?.newText?.map((data: any) => changeText(data));
  const newSubText = values?.newSubText?.map((data: any) => changeText(data));
  dispatch(
    editText({
      multi_title: newText,
      multi_sub_title: newSubText
    })
  );
  dispatch(
    editPreFontSize({
      multi_title: values?.newFontSize / 16,
      multi_sub_title: values?.newSubFontSize / 16
    })
  );
  dispatch(
    editFontSize({
      multi_title: values?.newFontSize / 16,
      multi_sub_title: values?.newSubFontSize / 16
    })
  );
  dispatch(
    editFontWeight({
      multi_title: values?.newFontWeight,
      multi_sub_title: values?.newSubFontWeight
    })
  );
  dispatch(
    editColor({
      multi_title: values?.newTextColor,
      multi_sub_title: values?.newSubTextColor
    })
  );
  // dispatch(editFontFamily(values?.fontFamily));
  // dispatch(editTextAlign(values?.textAlign));

  dispatch(
    editBtnText({
      multi_button: values?.newBtnText,
      multi_sub_button: values?.newCloseText
    })
  );
  dispatch(
    editBtnPreFontSize({
      multi_button: values?.newBtnFontSize / 16,
      multi_sub_button: values?.newCloseFontSize / 16
    })
  );
  dispatch(
    editBtnFontSize({
      multi_button: values?.newBtnFontSize / 16,
      multi_sub_button: values?.newCloseFontSize / 16
    })
  );
  dispatch(
    editBtnFontWeight({
      multi_button: values?.newBtnFontWeight,
      multi_sub_button: values?.newBtnFontWeight
    })
  );
  dispatch(
    editBtnColor({
      multi_button: values?.newBtnTextColor,
      multi_sub_button: values?.newCloseTextColor
    })
  );
  dispatch(
    editBtnBgColor(
      {
        multi_button: values?.BtnBgColorR,
        multi_sub_button: values?.CloseBgColorR
      },
      {
        multi_button: values?.BtnBgColorG,
        multi_sub_button: values?.CloseBgColorG
      },
      {
        multi_button: values?.BtnBgColorB,
        multi_sub_button: values?.CloseBgColorB
      },
      {
        multi_button: values?.BtnBgColorA,
        multi_sub_button: values?.CloseBgColorA
      }
    )
  );
  // dispatch(editBtnFontFamily(values?.btnFontFamily));
  // dispatch(editBtnTextAlign(values?.btnTextAlign));
};

export default BottomSheetImage;
